import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from '../../utils/axiosInstance';
import openNotification from '../../components/Common/OpenNotification';
import { INTERNAL_ORDER_MASTER_BULK_UPLOAD, INTERNAL_ORDER_MASTER_BULK_DOWNLOAD } from '../../api/endpoints';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";


const initialState = {
    loading : false,
    error : null,
};

export const bulkUploadFiles = createAsyncThunk('internalOrderMaster/bulkUpload', async ( {apiUrl,newObj}, { rejectWithValue }) => {
    try {
        // console.log("This got called");
        // console.log(data);
        // const apiUrl = INTERNAL_ORDER_MASTER_BULK_UPLOAD;
        // console.log("Hitting it now");
        // console.log(apiUrl);
        const response = await axiosInstance.post(apiUrl, newObj);
       
        openNotification('success', 'Upload Successful', `files uploaded successfully.`);
        return response.data;
    } catch (error) {
      
        openNotification('error', 'Upload Failed', error?.response?.data?.message || 'Something went wrong.');
        return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
    }
});

export const bulkDownloadFiles = createAsyncThunk('internalOrderMaster/bulkDownload', async ( apiUrl, { rejectWithValue }) => {
    try {

    const response = await axiosInstance.get(apiUrl, { responseType: 'blob' });

    // response.data is already a Blob
const blob = response.data;

// Set a default filename (or generate one yourself)
const fileName = "Report.xlsx";

const link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = fileName;
link.click();
URL.revokeObjectURL(link.href);

    openNotification('success', 'Download Successful', `Files downloaded successfully.`);

  } catch (error) {
    openNotification('error', 'Download Failed', error?.response?.data?.message || 'Something went wrong while downloading. Please try again.');
    return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
  }
});

const internalOrderMasterSlice = createSlice({ 
    name : 'internalOrderMaster',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(bulkUploadFiles.pending, (state) => {
             state.loading = true;
        })
        .addCase(bulkUploadFiles.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(bulkUploadFiles.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(bulkDownloadFiles.pending, (state) => {
                        state.loading = true;
                        state.error = null;
        })
        .addCase(bulkDownloadFiles.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(bulkDownloadFiles.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
} );

export default internalOrderMasterSlice.reducer;